var exports = {
  "iE": "xaee3c4fa--2b7961--wrapper",
  "ve": "xaee3c4fa--2b7961--pagination-wrapper",
  "Wi": "xaee3c4fa--2b7961--articles-wrapper",
};

module.exports = exports;
